import React from "react";

import { motion } from "framer-motion";

export default function MapLogo() {
  const variation = {
    initial: { pathLength: 0, pathOffset: 0, opacity: 0 },

    animate: {
      pathLength: [null, 1, 0],
      pathOffset: [null, 0, 1],
      opacity: [null, 1, 0],
      transition: {
        duration: 5,
        times: [0, 0.5, 1],
        delay: 1,
      },
    },
  };

  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      width="454"
      height="574"
      fill="none"
      initial="initial"
      animate="animate"
      viewBox="0 0 454 574"
      className="map-logo"
    >
      <motion.path
        stroke="#00FF75"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        variants={variation}
        d="M212.613 572.5c-35.684-29.608-93.664-95.5-127-145-13.69-20.327-41.5-53-68-124.5-36.5-98.481-1.2-167.576 26.5-205 47-63.5 111.499-96 180.5-96 55.999 0 144.355 33 188 96 27.468 39.649 55.518 92.5 29 205-9.084 38.535-47.5 97.5-71.5 128-42.107 53.51-94.5 107-128 141.5"
      ></motion.path>
      <motion.path
        stroke="#FF00E5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        variants={variation}
        d="M207.612 410.5c-60.5 0-155-48.5-159.5-180-3.302-96.5 79-180 177-180 101.5 0 181.974 85 178 180-5.144 123-97 180-156 180"
      ></motion.path>
      <motion.path
        stroke="#00A3FF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        variants={variation}
        d="M146.613 158h-31.5v179c.666 8.5 6.1 25.5 22.5 25.5h156c8.166-.667 24.5-5.9 24.5-21.5v-50.5"
      ></motion.path>
      <motion.path
        stroke="#FF0E1C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        variants={variation}
        d="M216.613 305.5c-2.834.667-8.9 4.5-10.5 14.5-2 12.5-2 28-8 35-4.8 5.6-7.334 6.167-10 6.5h-9.5c3.833-2.667 10.557-7.005 13-12.5 4-9 1.825-21.911-2.5-25-7-5-10.5-2.5-11.5 6.5s-1 14.5-4.5 20.5c-4.667 8-12.5 12.833-16.5 10.5 3.166-1.333 4.5-3.5 9-12.5 3.224-6.45.166-30.167 0-43.5-3.667-3.833-11.8-15.1-15-29.5-3.2-14.4 2-46 2-46-8.5-8.5-8.5-27.5-8.5-27.5-3.667-2.833-11.5-23-11.5-23 8.5 9.5 20 9.5 20 9.5l1-17.5c1.833 3 13.4 21 25 21h32.5c-15 16.5-24.719 22.761-26 32.5-2.5 19-2.834 20.5 3 27.5 20.5-4.5 76 20 76 20l15.5-5.5c12.333-5.667 36.4-24.2 34-53-2.4-28.8-46.334-32-68-30-20 .667-62.8-5.4-74-35-14-37 1-55 13-61.5 22.192-12.02 40.5-9.5 40.5-9.5-8.167 4.5-22.9 18.3-16.5 37.5 8 24 59 8 79.5 8.5s66 14 63.5 60-40.5 78.5-52 83c-9.2 3.6-28.5 8-28.5 8 3.833 3 10.9 14.7 8.5 37.5-2.4 22.8-8.167 44.167-10 50.5h-11c5-7.333 14.5-24.1 12.5-32.5-2-8.4-20-28-20-28l-1.5 33.5c-.667 4.667-3 14-12.5 24-4.931 5.19-15 3-15 3 9.5-7 20.2-24 17-36-3.2-12-6.5-17-14-21.5"
      ></motion.path>
    </motion.svg>
  );
}
